export enum CusomerCreatedFromType {
    PATIENT_APP = 'PATIENT_APP',
    ASISTENT = 'ASISTENT',
    EAMBULANTA = 'EAMBULANTA',
    HD = 'HD',
}
